<script>
/**
 * Page-header component
 * Encabezado sobrio de página: migas + un único <h1>. API conservada: props `title` e `items`.
 * - Sin título ni migas no se pinta nada (sin caja vacía).
 * - Slot opcional `actions` para acciones reales a la derecha del título.
 */
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    hasTitle() {
      return typeof this.title === "string" && this.title.trim() !== "";
    },
    // Migas sin texto (algunas vistas pasan items vacíos) no se pintan: evitan "/ /" sueltos.
    crumbs() {
      if (!Array.isArray(this.items)) return [];
      return this.items.filter(function (item) {
        return item && typeof item.text === "string" && item.text.trim() !== "";
      });
    },
    hasCrumbs() {
      return this.crumbs.length > 0;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div v-if="hasTitle || hasCrumbs" class="row">
    <div class="col-12">
      <header class="page-title-box">
        <nav v-if="hasCrumbs" aria-label="Migas de la vista">
          <b-breadcrumb :items="crumbs"></b-breadcrumb>
        </nav>
        <div v-if="hasTitle || $slots.actions" class="page-title-box__row">
          <h1 v-if="hasTitle" class="page-title">{{ title }}</h1>
          <div v-if="$slots.actions" class="page-title-box__actions">
            <slot name="actions"></slot>
          </div>
        </div>
      </header>
    </div>
  </div>
  <!-- end page title -->
</template>
